// extracted by mini-css-extract-plugin
export default {"container":"modalHeader_container__P6YxY","title":"modalHeader_title__GXEhv","subTitle":"modalHeader_subTitle__jR3+p","closeIcon":"modalHeader_closeIcon__KjyjJ"};